module.exports = __webpack_public_path__ + "static/media/Combined Shape.a0da85de.svg";